<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="B" :itemcode="pagecode"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div v-if="userdata.token">
					
				<!-- <div class="whitebox right_topbox" style="padding-bottom: 0;"> -->
					<!-- <div class="right_boxtitle">
						<span class="fl right_title">外商投资分析</span>
						<span class="fr showechart-c6" v-show="userdata.groupType != 2" @click="showechart=!showechart">{{showechart?'隐藏':'查看'}}图表</span>
					</div> -->
					<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">企业</span>
						<span class="fr showechart-c6" v-show="userdata.groupType != 2" @click="showechart=!showechart">{{showechart?'隐藏':'查看'}}图表</span>
						<div class="fl search-box ot-search-box">
							<span class="searchtype">{{title}}</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> 
					</div> 
					<div>
						<div class="opport-screen-list1">
							<div class="spage-searchbox ">
								<dl class="opport-screen bdbe">
								<dt class="fl">企业库</dt>
								<dd class="fl" v-if="curWebsite.type != 5"> 
									<span v-for="(item,index) in enterinarr" :key="index" @click="routerself('/enterpriseList?type='+item.type+'&Pt='+item.curindex)" class="a-screen">{{item.name}}</span>
									<span @click="routerself('/totalEnterprises')" class="a-screen">全部内资企业库</span>
									<span class="blueline"></span>
									<span class="a-screen" @click="routerself('/foreignEnterprises')">境外上市企业库</span> 
									<span class="a-screen current">外资企业库</span>  
									<!-- <el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i	class="el-icon-question listeltootipicon" ></i>
										<div slot="content" class="list_tips">
											<p>上市公司：A股上市的公司 </p>
											<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p>
											<p>创新企业：被专业投资机构认可并成功融资的企业</p>
											<p>优质企业：具有市场竞争优势和持续发展潜力的企业</p> 
											<p>外资企业：外商投资的企业</p>
											<p>境外上市企业：在境外证券交易所公开上市的企业</p>
										</div>
									</el-tooltip> -->
										<video-teaching :type="1"></video-teaching>
								</dd>
							</dl> 
							<dl class="opport-screen bdbe">
								<dt class="fl">企业类型</dt>
								<dd class="fl" v-if="curWebsite.type != 5">
									<span class="a-screen" @click="routerself('/forcapEnterprise')">外资企业</span>
									<span class="a-screen current">外商投资企业</span>

								</dd>
							</dl>
								<dl class="opport-screen bdbe">
									<dt class="fl">投资来源</dt>
									<dd class="fl">
										<span :class="countryValue == ''?'a-screen current':'a-screen'"
											@click="countryValue = '';getCompanyList(1)">全部</span>
										<span :key="index" v-for="(item,index) in countryOptions"
											:class="countryValue == item.areaId ?'a-screen current':'a-screen'"
											@click="SouceToggle(item)">{{item.areaName}}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="cityOption.length>0">
									<dt class="fl">投资地点</dt>
									<dd class="fl">
										<span :class="cityId === '' ?'a-screen current':'a-screen'"
											@click="cityId = '';getCompanyList(1)">全部</span>
										<span :key="index" v-for="(item,index) in cityOption"
											:class="cityId === item.areaId ?'a-screen current':'a-screen'"
											@click="cityToggle(item)">{{item.areaName}}</span>
									</dd>
								</dl>
								
								
								<dl class="opport-screen bdbe">
									<dt class="fl">产业分类</dt>
									<dd class="fl">
										<span :class="chooseNotion == 0 ?'a-screen current':'a-screen'"
											@click="notionlist2=[];chooseNotion2='';chooseNotion = 0;getCompanyList(1);">全部</span>
										<span :key="index" v-for="(item,index) in notionlist"
											:class="chooseNotion == item.value ?'a-screen current':'a-screen'"
											@click="chooseNotionFn(item,1)">{{item.name}}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="notionlist2.length>0">
									<dt class="fl titleop">细分产业</dt>
									<dd class="fl">
										<span :class="chooseNotion2 == '' ?'a-screen current':'a-screen'"
											@click="chooseNotion2 = '';getCompanyList(1);">全部</span>
										<span :key="index" v-for="(item,index) in notionlist2"
											:class="chooseNotion2 == item.value ?'a-screen current':'a-screen'"
											@click="chooseNotionFn(item,2)">{{item.name}}</span>
									</dd>
								</dl>
							</div>
						</div>
						

					</div>
				</div>
				<div class="whitebox">
					<!-- 柱状图 概念企业数量 -->
					<div class="fixedEchartBar1 w95mg oh por pt-2" v-show="showechart && userdata.groupType != 2">
						<div class="fl" style="width: 48%;margin-right: 40px;" v-show="countryValue == '' || cityId == '' || chooseNotion == 0 || chooseNotion2 == ''">
							<div class="land-ecahrt-title">
								<h5 :class="cityInvestType == 1 ? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',1)" v-show="countryValue == ''">投资来源地分布 </h5>
								<h5 :class="cityInvestType == 2 ? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',2)" v-show="cityId == ''">投资地点分布 </h5>
								<h5 :class="cityInvestType == 3 ? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',3)" v-show="chooseNotion == 0">投资项目行业分布</h5>
								<h5 :class="cityInvestType == 4? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',4)" v-show="chooseNotion2 == '' && chooseNotion != 0">投资项目行业分布</h5>
							</div>
							<div id="fixedEchartPie" class="echart-line-box" :style="'width:'+echartWidth2+'px;'" ></div>
						</div>
						<div class="fl" style="width: 48%;">
							<div class="land-ecahrt-title tac"><b>历年投资数量</b></div>
							<div id="fixedEchartBar" class="echart-line-box" :style="'width:'+echartWidth2+'px;'"></div>
						</div>
						<span class="closebtn" @click="showechart=false"></span>
					</div>
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
					</div>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpristlist.length!=0">
							<tr>
								<th>序号</th>
								<th>企业名称 </th>
								<th>
									<div :class="{'td_sortname ':true,'current':orderField == 1}" @click="tablesort(1)">
										<span :class="{'sortname ':true,'current':orderField ==  1}">注册资本<i 	:class="orderType == 1? 'timesorticon up':'timesorticon down'"></i></span>
									</div> 
								</th>
								<th>所属行业</th>
								<th>投资地点</th>
								<th>
									<div :class="{'td_sortname ':true,'current':orderField == 0}" @click="tablesort(0)">
										<span :class="{'sortname ':true,'current':orderField == 0}">投资时间<i :class="orderType == 1?'timesorticon up':'timesorticon down'"></i></span>
									</div> 
								</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist" v-if="i<freeUserNum">
								<td>{{20*(page-1)+i+1}}</td>
								<td class="title"  @click="routerlinkarry('/investEnterpirseDetail',{'id':list.stockCode,'type':2})">{{list.title}}  </td>
								<td>{{list.regCapital}}</td>
								<td>{{list.industry}}</td>
								<td>{{list.area}}</td>
								<td>{{list.createTime}}</td>
							</tr>
						</table>
						<div class="w95mg"><freeUserTips :type="2" :bgtype="27" v-if="enterpristlist.length>3  && userdata.isFree" ></freeUserTips></div>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="getCompanyList">
						</zpagenav>
					</div>
				</div>
			
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	import { dataInJs } from "@/utils/city.js";
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
	export default {
		name: 'index',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite: this.$api.getWebsiteType(),
				echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
				title: "外商投资分析",
				areaData:dataInJs(),
				userdata: {},
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数
				enterpristlist: [],
				countryOptions: [],
				pagecode: 'A-WZQY',
				showechart: true,
				countryValue: '',
				sreachType: 0,
				kwtextsearchtext: '',
				searchtext: "",
				kwtextsearch: '',
				notionlist: [],
				chooseNotion: 0,
				orderField: 0,
				orderType: 0,
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				countryChartData: [],
				cityChartData: [],
				cityInvestType: 1,
				notionlist2:[],
				chooseNotion2:0,
				cityId:'',
				countyId:'',
				cityOption:[],
				getcityListNum:1,
				freeUserNum:3,
				//*页面公用*/
				enterinarr: [
					{curindex: 1,type: 9,name: "龙头企业库",tagnum:10010,}, 
					{curindex: 2,type: 2,name: "科创企业库",tagnum:10010,},
					], 
				isShowFreeUserTips: false
			}
		},
		components: {
		 freeUserTips
		}, 
		beforeCreate() {},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var that = this;
			this.userdata = this.getuseriformation(); 
			if(this.userdata.token){
				this.freeUserNum=this.userdata.isFree ? 3 : this.pageSize;
				this.getNotionList().then((res)=> {
				this.getCountryList().then((res)=> {
					this.getCompanyList();
				})	;
				});
			}
			
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
		},
		methods: {

			//搜索企业
			searchkwfun(){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					this.searchtext='';
					return;
				}
				this.searchtext = $.trim(this.searchtext);
				this.getCompanyList(1,'search');
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			}, 
			getCountryList(){
				return new Promise((resolve, reject) => {
					this.bus.$emit('loading', true);
					var that = this;
					this.$axios.get(this.$api.common.invest.country(), {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) { 
						if (res.data.success) { 
							console.log('获取国家列表',res);
							that.countryOptions = res.data.list;
							resolve(true);
							that.bus.$emit('loading', false);
						} else {

						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
				})
			},
			//城市地区切换
			cityToggle(item){
				console.log('城市地区切换',item);
				this.cityId = item.areaId;
				this.getCompanyList();
			},
			//投资来源切换
			SouceToggle(item){
				console.log('投资来源切换',item);
				this.countryValue=item.areaId;
				this.getCompanyList();
			},
			
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getCompanyList();
			},
			//获取行业分类
			getNotionList() {
				return new Promise((resolve, reject) => {
					this.bus.$emit('loading', true);
					var that = this;
					this.$axios.get(this.$api.cyl.parameter.get()+"?parentValue="+this.chooseNotion, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) { 
						if (res.data.success) { 
							console.log('获取行业分类',res)
							if(that.chooseNotion!=0){
								that.notionlist2 = res.data.list;
							}else{
								that.notionlist = res.data.list;
							}
							resolve(true);
							that.bus.$emit('loading', false);
						} else {

						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
				})
			}, 
			//行业筛选
			chooseNotionFn(item, type) {
				console.log('xuanze', item, type);
				if(type == 1){
					this.chooseNotion = item.value;
					this.chooseNotion2 ='';
					this.getNotionList();
				}else if(type == 2){
					this.chooseNotion2 = item.value;
				}
				this.getCompanyList();
			},
			pageHandler(page) { 
				this.getCompanyList(page);
			},
			getCompanyList(pages) {
				this.bus.$emit('loading', true);
				this.page = pages ? pages : 1;
				var that = this;
				var countyList =[];
				var querydata={page:this.page,country:this.countryValue,city:this.cityId,industry:this.chooseNotion,industry2:this.chooseNotion2,kw:this.searchtext}; 
				let ajaxUrl = this.$api.common.invest.list(querydata); 
				ajaxUrl=ajaxUrl+'&orderField='+this.orderField+'&orderType='+this.orderType; 
				// 4aef66eae5b3026530eb2625048bf8bc //本地投资趋势只有这个token才有数据 this.userdata.token
				this.$axios.get(ajaxUrl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(ajaxUrl, res);
					if (res.data.success) {
						console.log('列表数据', res.data,that.getcityListNum);
						that.enterpristlist = res.data.list;
						that.countryChartData = res.data.data.country;
						that.cityChartData = res.data.data.city;
						that.industryChartData=res.data.data.industry;
						that.industry2ChartData=res.data.data.industry2;
						if(that.getcityListNum == 1){
							let temCityOption = res.data.data.city;
							//直辖市要展示区县数据
							temCityOption.forEach(item => {
								item.areaName = item.name;
								if(item.name=='北京市' || item.name=='上海市' || item.name=='天津市' || item.name=='重庆市'|| item.name=='南昌市'){
									that.areaData.forEach((list,i) => {
										// console.log('全国列表',item.name,list.areaName,i,item.name == list.areaName,that.cityOption);
										if(item.name == list.areaName){
											countyList = list.children;
										}
									});
									console.log('this.ciyoptins',countyList);
								}else{
									countyList = temCityOption;
								} 
							});
							that.cityOption = countyList;
							console.log('第一次请求赋值城市数据',that.cityOption);
						}
						if(res.data.data.year.length>0){
								that.rankFun('fixedEchartBar', res.data.data.year);
						} 
						var pietype = 1;
							if(that.countryValue === ''){
								pietype = 1;
							}else if(that.cityId === ''){
								pietype = 2;
							}else if(that.chooseNotion == 0){
								pietype = 3
							}
							else if(that.chooseNotion2 == ''){
								pietype = 4
							}
					that.PiechartFun('fixedEchartPie',pietype);
						//页数和导出
						that.totalPage = res.data.totalPage;
						that.pageSize = res.data.pageSize;
						that.total = res.data.totalRecord; 
						that.haspage = res.data.list.length == res.data.pageSize; 
						that.kwtextsearch = that.searchtext != "";
						that.kwtextsearchtext = that.searchtext; 
						that.getcityListNum ++;
					} else {
						that.$message({type:'warning',message:res.data.msg}); 
					}
					that.bus.$emit('loading', false);
					that.showechart=res.data.success;
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//弹出图表 概念企业数量排名
			rankFun(el, data) {
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el));
				var that = this,
					xline = [],
					seriesline = [];
				var datalen = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					xline.push(data[i].name);
					seriesline.push(data[i].num);
				};
				// console.log('折线图',data, xline, seriesline)
				var option = {
					tooltip: {
						formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c}"
					},
					xAxis: {
						type: 'category',
						data: xline
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: seriesline,
						type: 'line',
						smooth: true
					}]
				};
				chart.setOption(option);
				var startCharts = null;
			},
			PiechartFun(el,type,data) {
				console.log('piechart',el,type);
				this.cityInvestType=type;
				if(type == 1){
					data=this.countryChartData;
				}else if(type == 2){
					data=this.cityChartData;
				}else if(type == 3){
					data=this.industryChartData;
				}else if(type == 4){
					data = this.industry2ChartData;
				}
	 
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var regionalchart = echarts.init(document.getElementById(el));
				let newdata=[],otherNum=0;
				for (var i = 0; i < data.length; i++) {
					if(i<10){
						newdata.push({name:data[i].name,value:data[i].num});
					}else{
						otherNum=otherNum+data[i].num;
					} 
				}
				newdata.push({name:'其他',value:otherNum})
				var that = this;
				var option = {
					title: {
						text: ' ',
					},
					tooltip: {
						trigger: 'item'
					},
					// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
					// },
					series: [{
						name: '',
						type: 'pie',
						radius: '60%',
						// center: ["52%", "50%"],
						data: newdata,
						label: {
							show: true,
							color: '#333',
							fontSize: 12,
							position: 'outside',
							formatter: '{b} : {d}%',
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				regionalchart.setOption(option);
			},


		}
	}
</script>

<style lang="scss">
	.orderField {
		display: block;
		width: 100%;
		height: 100%;

	}
</style>